import angular from 'angular';
import VersionConst from '../constants/version';

class Version {
	constructor($window, $http, $interval, $q, VersionConst) {
		this.http = $http;
		this.q = $q;
		this.local = VersionConst;
		// Poll for update every 20 min
		$interval(() => this.check(), 1.2e6, 0, false);

	}
	ping() {
		return this.http({
			url: '/manifest.json',
			method: 'GET'
		});
	}
	check() {
		var v = this.q.defer();
		this.ping().then(response => {
			this.origin = response.data.version;
			if (this.local && this.origin) {
				let local = this.local.split('.');
				let origin = this.origin.split('.');

				this.update = local.length !== origin.length ||
					origin.some((val, i) => val !== local[i]);

				v.resolve(this.update);
			} else {
				v.reject();
			}
		}, () => {
			v.reject()
		});

		return v.promise;
	}
}
Version.$inject = ['$window', '$http', '$interval', '$q', 'VersionConst'];

export default angular.module('services.version', [VersionConst])
	.service('VersionServ', Version)
	.name;



// WEBPACK FOOTER //
// ./project/services/version.js